import { useEvidenceSampleSessionDetails } from 'api';
import { useState } from 'react';
import { EvidenceSessionPhotoGallery, Grid, MediaDialog, Stack, Typography, useBreakpoint } from 'ui';

import { MaterialSampleBreakdown } from '../../../breakdowns';

export const EvidenceSampleSessionDetails = ({
  parentId,
  siteMaterialId,
}: {
  parentId: number;
  siteMaterialId: number;
}) => {
  const { isMobile } = useBreakpoint();
  const { evidence, composition, material } = useEvidenceSampleSessionDetails(parentId, siteMaterialId);

  const carouselMedia = evidence.map((file) => file.fullResolutionSrc);

  const [selectedImage, setSelectedImage] = useState<string>('');

  const handleSelect = (src: string) => {
    const relatedMedia = evidence.find((file) => file.src === src || file.fullResolutionSrc === src);
    setSelectedImage(relatedMedia?.fullResolutionSrc || '');
  };

  return (
    <>
      <Grid container spacing={3} data-testid="evidence-session-details">
        <Grid item xs={12} md={6} data-testid="photo-evidence">
          <Stack gap={2}>
            <Typography variant="h6" fontWeight="bold">
              Sample images
            </Typography>
            {evidence ? (
              <EvidenceSessionPhotoGallery
                photoEvidence={evidence}
                maxImages={isMobile ? 6 : 8}
                handleClick={(photo) => handleSelect(photo.src)}
              />
            ) : (
              <Typography>No data</Typography>
            )}
          </Stack>
        </Grid>
        <Grid item xs={12} md={6} data-testid="composition-report">
          <Stack gap={0.5}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Manual sample analysis
            </Typography>
            {composition ? (
              <MaterialSampleBreakdown
                items={composition.breakdown.map((item) => ({
                  label: item.name_display,
                  unit: item.unit,
                  unit_display: item.unit_display,
                  value: item.value,
                }))}
                variant={material}
                precision={2}
              />
            ) : (
              <Typography>No data</Typography>
            )}
          </Stack>
        </Grid>
      </Grid>

      <MediaDialog
        open={Boolean(selectedImage)}
        selectedMedium={selectedImage}
        onClose={() => setSelectedImage('')}
        media={carouselMedia}
        handleNavigate={handleSelect}
      />
    </>
  );
};
